// Libraries
import { Card, Alert, FormElems, LoginFlowComps } from '../../components';
import {
    loginRequest,
    loginError,
    resendOtpRequest,
    resendOtpError,
    validateOtpRequest,
} from '../../redux/common/auth/auth.actions';
import loginImg from '../../static/images/otp-img.png';
import useOtpTimes from '../../hooks/useOtpTimes';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import validate from './validator';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';

// Components

// Actions

// Images

// Hooks

// Constant

// Validator

// Styles
import './otp.scss';

const Otp = props => {
    const { actions, handleSubmit, auth, change, untouch } = props;
    const { otpMail, otpId, otpDetails, otpResend } = auth;
    const [seconds, setSeconds] = useOtpTimes(60);
    const [isReset, setIsReset] = useState(false);

    useEffect(() => {
        if (otpResend.isSuccess) {
            setSeconds(60);
            toast.info(SUCCESS_MESSAGES.OTP);
        }
        return () => {
            if (otpResend.isSuccess) {
                actions.resendOtpError('');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otpResend.isSuccess]);

    /**
     * Validate on otp submit
     *
     * @returns {undefined}
     */
    function handleValidateOtp(values) {
        const request = {
            otp: values.otp,
            otpId,
        };
        actions.validateOtpRequest(request);
    }

    useEffect(() => {
        if (otpDetails.error) {
            change('otp', '');
            untouch('otp-form', 'otp');
            setIsReset(true);
        }
        return () => {
            setIsReset(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otpDetails.error]);

    /**
     * Resend on otp resend
     *
     * @returns {undefined}
     */
    function handleResendOtp(event) {
        event.preventDefault();
        const request = {
            otpId,
        };
        actions.resendOtpRequest(request);
    }

    return (
        <div className="otp-wrapper">
            <Card customClass="login-card">
                <LoginFlowComps.ImageSplitView splitImg={loginImg}>
                    <div className="otp-form-wrapper">
                        <div className="form-head">OTP Verification</div>
                        <div className="form-sub-head">
                            An email with a verification code is sent to{' '}
                            {otpMail.replace(/\*/g, '•')}
                        </div>
                        <form
                            className="otp-form"
                            onSubmit={handleSubmit(handleValidateOtp)}
                        >
                            <div className="form-field">
                                <Field
                                    name="otp"
                                    component={FormElems.OtpInput}
                                    wrapperClass="otp-field"
                                    inputClassName="otpInput"
                                    id="otpInput"
                                    length={6}
                                    isNumberInput
                                    autoFocus
                                    isReset={isReset}
                                    setReset={value => setIsReset(value)}
                                    serverError={otpDetails.error}
                                />
                            </div>

                            {auth.loginError && (
                                <Alert customClass="login-alert">
                                    {auth.loginError}
                                </Alert>
                            )}

                            <div className="form-btn">
                                <FormElems.Button
                                    buttonType="secondary"
                                    customClass={seconds && 'cancel-button'}
                                    isDisable={seconds}
                                    type="button"
                                    id="resendCTA"
                                    text={
                                        seconds
                                            ? `RESEND - ${seconds}`
                                            : 'RESEND'
                                    }
                                    handleClick={handleResendOtp}
                                />
                                <FormElems.Button
                                    buttonType="primary"
                                    text="CONTINUE"
                                    id="validateCTA"
                                />
                            </div>
                        </form>
                    </div>
                </LoginFlowComps.ImageSplitView>
            </Card>
        </div>
    );
};

Otp.propTypes = {
    auth: PropTypes.object,
    handleSubmit: PropTypes.func,
    actions: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            loginRequest,
            loginError,
            resendOtpRequest,
            resendOtpError,
            validateOtpRequest,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'otp-form',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(Otp);
